import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import {
  AlertInfo,
  CollapsibleStyle,
  ContentStyle,
  ScrollBarStyle,
} from "../../Theme";
import useCollapse from "react-collapsed";
import { loadingNotifications } from "../../Redux/Slice/NotificationSlice";
import { useDispatch, useSelector } from "react-redux";
import PlusIcon from "@mui/icons-material/AddOutlined";
import CircleIcon from "@mui/icons-material/Circle";
import MinusIcon from "@mui/icons-material/RemoveOutlined";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import moment from "moment";

function Collapsible(props: any) {
  const config = {
    defaultExpanded: false,
    duration: 500,
  };
  const { notSeen } = props;
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse(config);
  return (
    <CollapsibleStyle>
      <Box
        className={notSeen ? "header active" : "header"}
        {...getToggleProps()}
        {...config}
      >
        <Typography component="h6" variant="subtitle1">
          {props.title} {isExpanded ? <MinusIcon /> : <PlusIcon />}
        </Typography>
      </Box>
      <Box className="content" {...getCollapseProps()}>
        {props.content}
      </Box>
    </CollapsibleStyle>
  );
}

export default function Notifications() {
  const dispatch = useDispatch();
  const notificationData = useSelector((state: any) => {
    return { ...state?.NotificationSlice };
  }); //To get data from redux store state
  const [activeId, setActiveId] = useState<any>("");
  const params = {
    isNewItems: false,
  };

  // const getDaysAgo = (date: string) => {
  //   const targetDate = moment(date);
  //   const today = moment();
  //   const daysAgo = today.diff(targetDate, "days");
  //   return (
  //     <>
  //       {daysAgo === 0 && targetDate.format("hh:mm A")}
  //       {daysAgo === 1 && "Yesterday"}
  //       {daysAgo > 1 && `${daysAgo} days ago`}
  //     </>
  //   );
  // };
  const getDaysAgo = (date: string) => {
    const targetDate = moment(date);
    const today = moment();
    const yearsAgo = today.diff(targetDate, "years");
    targetDate.add(yearsAgo, "years");
    const monthsAgo = today.diff(targetDate, "months");
    targetDate.add(monthsAgo, "months");
    const daysAgo = today.diff(targetDate, "days");

    if (yearsAgo > 0) {
      return `${yearsAgo} year${yearsAgo > 1 ? "s" : ""} ago`;
    } else if (monthsAgo > 0) {
      return `${monthsAgo} month${monthsAgo > 1 ? "s" : ""} ago`;
    } else if (daysAgo > 1) {
      return `${daysAgo} days ago`;
    } else if (daysAgo === 1) {
      return "Yesterday";
    } else {
      return targetDate.format("hh:mm A");
    }
  };

  const onLoadNotifications = () => {
    dispatch(loadingNotifications(params));
  };
  useEffect(() => {
    onLoadNotifications();
  }, []);

  useEffect(() => {
    if (
      notificationData?.AllNotifications?.notSeenNotificationList?.length > 0
    ) {
      setActiveId(
        notificationData?.AllNotifications?.notSeenNotificationList?.[0]?.id
      );
    } else {
      setActiveId(
        notificationData?.AllNotifications?.seenNotificationList?.[0]?.id
      );
    }
  }, [
    notificationData?.AllNotifications?.notSeenNotificationList,
    notificationData?.AllNotifications?.seenNotificationList,
  ]);

  if (notificationData.isLoading) {
    return (
      <>
        <ContentStyle>
          <Typography component="h6" color="primary" variant="h6">
            Notifications
          </Typography>
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            height={"50vh"}
          >
            <CircularProgress color="primary" />
          </Grid>
        </ContentStyle>
      </>
    );
  }

  if (notificationData.error) {
    return (
      <>
        <ContentStyle>
          <Typography component="h6" color="primary" variant="h6">
            Notifications
          </Typography>
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            height={"50vh"}
          >
            <Typography
              fontWeight={"bold"}
              fontStyle={"italic"}
              color={"primary"}
            >
              {notificationData.message}
            </Typography>
          </Grid>
        </ContentStyle>
      </>
    );
  }

  if (
    notificationData?.AllNotifications?.seenNotificationList?.length === 0 &&
    notificationData?.AllNotifications?.notSeenNotificationList?.length === 0
  ) {
    return (
      <>
        <ContentStyle>
          <Typography component="h6" color="primary" variant="h6">
            Notifications
          </Typography>
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            height={"50vh"}
          >
            <Typography
              fontWeight={"bold"}
              fontStyle={"italic"}
              color={"primary"}
            >
              No notifications found
            </Typography>
          </Grid>
        </ContentStyle>
      </>
    );
  }
  return (
    <>
      <ContentStyle>
        <Typography component="h6" color="primary" variant="h6">
          Notifications
        </Typography>
        <Grid container>
          <Grid item xs={12} md={6}>
            <ScrollBarStyle
              className="full"
              style={{ height: 500, overflow: "auto" }}
            >
              {notificationData?.AllNotifications?.notSeenNotificationList
                ?.length > 0 &&
                notificationData?.AllNotifications?.notSeenNotificationList?.map(
                  ({
                    id,
                    notificationname,
                    notificationdescription,
                    createddate,
                  }: any) => (
                    <CollapsibleStyle>
                      <Box
                        className={id === activeId ? "header active" : "header"}
                        key={id}
                        onClick={() => {
                          setActiveId(id);
                        }}
                      >
                        <Typography component="h6" variant="subtitle1">
                          <Typography component="span" variant="body2">
                            <CircleIcon fontSize="small" />
                            {notificationname}
                          </Typography>
                          <Typography component="span" variant="body2">
                            {getDaysAgo(createddate)}
                            {<KeyboardArrowRightIcon />}
                          </Typography>
                        </Typography>
                      </Box>
                    </CollapsibleStyle>
                    // <Grid
                    //   container
                    //   item
                    //   xs={12}
                    //   spacing={0}
                    //   alignItems="flex-start"
                    //   justifyContent="flex-start"
                    //   rowSpacing={4}
                    // >
                    //   <Grid item xs={12} key={id}>
                    //     <Collapsible
                    //       notSeen={true}
                    //       defaultExpanded="true"
                    //       isExpanded="true"
                    //       title={notificationname}
                    //       content={
                    //         <Typography component="div" variant="body2">
                    //           {notificationdescription}
                    //         </Typography>
                    //       }
                    //     />
                    //   </Grid>
                    // </Grid>
                  )
                )}
              {notificationData?.AllNotifications?.seenNotificationList
                ?.length > 0 &&
                notificationData?.AllNotifications?.seenNotificationList?.map(
                  ({
                    id,
                    notificationname,
                    notificationdescription,
                    createddate,
                  }: any) => (
                    <CollapsibleStyle>
                      <Box
                        className={id === activeId ? "header active" : "header"}
                        key={id}
                        onClick={() => {
                          setActiveId(id);
                        }}
                      >
                        <Typography component="h6" variant="subtitle1">
                          <Typography component="span" variant="body2">
                            {notificationname}
                          </Typography>
                          <Typography component="span" variant="body2">
                            {getDaysAgo(createddate)}
                            {<KeyboardArrowRightIcon />}
                          </Typography>
                        </Typography>
                      </Box>
                    </CollapsibleStyle>
                    // <Grid
                    //   container
                    //   item
                    //   xs={12}
                    //   spacing={0}
                    //   alignItems="flex-start"
                    //   justifyContent="flex-start"
                    //   rowSpacing={4}
                    // >
                    //   <Grid item xs={12} key={id}>
                    //     <Collapsible
                    //       notSeen={false}
                    //       defaultExpanded="true"
                    //       isExpanded="true"
                    //       title={notificationname}
                    //       content={
                    //         <Typography component="div" variant="body2">
                    //           {notificationdescription}
                    //         </Typography>
                    //       }
                    //     />
                    //   </Grid>
                    // </Grid>
                  )
                )}
            </ScrollBarStyle>
          </Grid>
          <Grid item xs={12} md={6}>
            {notificationData?.AllNotifications?.notSeenNotificationList
              ?.filter((each: any) => each?.id === activeId)
              .map((each: any) => (
                <Stack
                  key={each?.id}
                  height={500}
                  spacing={2}
                  marginBottom={3}
                  marginLeft={3}
                >
                  <AlertInfo className="gray ni" height={"100vh"}>
                    {/* <Typography
                      variant="body1"
                      component={"div"}
                      fontWeight={600}
                      my={2}
                    >
                      {getDaysAgo(each?.createddate)}
                    </Typography>{" "} */}
                    <Typography
                      variant="h6"
                      color="primary"
                      overflow={"auto"}
                      component={"div"}
                    >
                      {each?.notificationname}
                    </Typography>{" "}
                    <Typography
                      variant="body2"
                      overflow={"auto"}
                      component={"div"}
                      marginY={2}
                    >
                      {moment(each?.createddate).format("MM/DD/YYYY")} at{" "}
                      {moment(each?.createddate).format("hh:mm A")}
                    </Typography>{" "}
                    <Typography variant="body2" component={"div"}>
                      {each?.notificationdescription}
                    </Typography>{" "}
                  </AlertInfo>
                </Stack>
              ))}
            {notificationData?.AllNotifications?.seenNotificationList
              ?.filter((each: any) => each?.id === activeId)
              .map((each: any) => (
                <Stack
                  key={each?.id}
                  height={500}
                  spacing={2}
                  marginBottom={3}
                  marginLeft={3}
                >
                  <AlertInfo className="gray ni" height={"100vh"}>
                    {/* <Typography
                      variant="body1"
                      component={"div"}
                      overflow={"auto"}
                      fontWeight={600}
                      my={2}
                    >
                      {getDaysAgo(each?.createddate)}
                    </Typography>{" "} */}
                    <Typography
                      variant="h6"
                      color="primary"
                      overflow={"auto"}
                      component={"div"}
                    >
                      {each?.notificationname}
                    </Typography>{" "}
                    <Typography
                      variant="body2"
                      overflow={"auto"}
                      component={"div"}
                      marginY={2}
                    >
                      {moment(each?.createddate).format("MM/DD/YYYY")} at{" "}
                      {moment(each?.createddate).format("hh:mm A")}
                    </Typography>{" "}
                    <Typography
                      variant="body2"
                      overflow={"auto"}
                      component={"div"}
                    >
                      {each?.notificationdescription}
                    </Typography>{" "}
                  </AlertInfo>
                </Stack>
              ))}
          </Grid>
        </Grid>
      </ContentStyle>
    </>
  );
}
